let product_slider = new Swiper(".p_product_slider", {
  slidesPerView: 1,
  loop: true,
  centeredSlides: true,
  speed: 500,
  loopAdditionalSlides: 3,
  spaceBetween: 20,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {
    el: ".swiper-pagination",
    type: "fraction",
  },
  breakpoints: {
    // スライドの表示枚数：500px以上の場合
    768: {
      slidesPerView: 1,
      spaceBetween: 25,
    },
  },
});

const acc_ttl2 = Array.from(
  document.querySelectorAll(".p_product_accordionItem_ttl")
);

for (let i = 0; i < acc_ttl2.length; i++) {
  let ttl = acc_ttl2[i];
  let content = ttl.nextElementSibling;
  ttl.addEventListener("click", () => {
    ttl.classList.toggle("is-active");
    console.log(content.style.height);
    if (content.style.height) {
      content.style.height = null;
    } else {
      content.style.height = content.scrollHeight + "px";
    }
  });
}

let product__bandleSlider = new Swiper(".product__bandleSlider", {
  slidesPerView: 1,
  loop: false,
  centeredSlides: true,
  speed: 500,
  spaceBetween: 30,
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  pagination: {          // ← 追加
    el: ".swiper-pagination",
    type: "fraction",
  },
  breakpoints: {
    // スライドの表示枚数：500px以上の場合
    768: {
      slidesPerView: 1,
      spaceBetween: 40,
    },
  },
});

function modalOpen01() {
  const modal = document.querySelector(".product__aboutModal01");
  const mask = document.querySelector(".product__aboutModal_mask");
  const modalOpen = document.querySelector(".modalOpen01");
  const body = document.querySelector("body");
  if (modalOpen) {
    modalOpen.addEventListener("click", function () {
      mask.classList.add("is-active");
      modal.classList.add("is-active");
      body.classList.add("is_fixed");
    });
  }
}
function modalOpen02() {
  const modal = document.querySelector(".product__aboutModal02");
  const mask = document.querySelector(".product__aboutModal_mask");
  const modalOpen = document.querySelector(".modalOpen02");
  const body = document.querySelector("body");
  if (modalOpen) {
    modalOpen.addEventListener("click", function () {
      mask.classList.add("is-active");
      modal.classList.add("is-active");
      body.classList.add("is_fixed");
    });
  }
}
function modalClose01() {
  const modal01 = document.querySelector(".product__aboutModal01");
  const mask = document.querySelector(".product__aboutModal_mask");
  const modalClose = document.querySelector(".modalClose01");
  const body = document.querySelector("body");
  if (modalClose) {
    modalClose.addEventListener("click", function () {
      mask.classList.remove("is-active");
      modal01.classList.remove("is-active");
      body.classList.remove("is_fixed");
    });
  }
  if (mask) {
    mask.addEventListener("click", function () {
      mask.classList.remove("is-active");
      modal01.classList.remove("is-active");
      body.classList.remove("is_fixed");
    });
  }
}
function modalClose02() {
  const modal02 = document.querySelector(".product__aboutModal02");
  const mask = document.querySelector(".product__aboutModal_mask");
  const modalClose = document.querySelector(".modalClose02");
  const body = document.querySelector("body");
  if (modalClose) {
    modalClose.addEventListener("click", function () {
      mask.classList.remove("is-active");
      modal02.classList.remove("is-active");
      body.classList.remove("is_fixed");
    });
  }
  if (mask) {
    mask.addEventListener("click", function () {
      mask.classList.remove("is-active");
      modal02.classList.remove("is-active");
      body.classList.remove("is_fixed");
    });
  }
}
modalOpen01();
modalOpen02();
modalClose01();
modalClose02();

(function () {
  /** テキストのクリップボードのコピー処理 */
  const cc = document.querySelectorAll(".cc");
  for (let k in cc) {
    if (typeof cc[k].addEventListener === "undefined") continue;
    cc[k].addEventListener("click", (event) => {
      copyToClipboard(event.target.textContent);
      cc[k].classList.add("is-copied");
      setTimeout(function () {
        cc[k].classList.remove("is-copied");
      }, 500);
    });
  }
})();

// クリップボードへコピー（コピーの処理）
function copyToClipboard(tagValue) {
  if (navigator.clipboard) {
    return navigator.clipboard.writeText(tagValue).then(function () {
      messageActive();
    });
  } else {
    tagText.select();
    document.execCommand("copy");
    messageActive();
  }
}

// メッセージを表示
function messageActive() {
  message.classList.add("is-active");
  setTimeout(() => {
    message.classList.remove("is-active");
  }, 500);
}

var wishlist = document.querySelector("#wishlist-hero-product-page-button");
var productForm = document.querySelector(".form_pc .product-form");
if (productForm && wishlist) {
  productForm.after(wishlist);
}

var productButtonArea = document.querySelector(".form_pc");
if (productButtonArea) {
  function productButtonHandler() {
    productButtonArea.classList.toggle(
      "fixed",
      productButtonArea.getBoundingClientRect().y < window.innerHeight - 57
    );
  }

  window.addEventListener("resize", productButtonHandler, { passive: false });
  window.addEventListener("scroll", productButtonHandler, { passive: false });
  productButtonHandler();
}

if (window.matchMedia("(max-width: 767px)").matches) {
  // TOPボタン
  const backbtn = document.querySelector(".product-form__buttons_sp");
  window.addEventListener("scroll", () => {
    let scroll_Y = window.scrollY;
    //console.log(scroll_Y)
    if (scroll_Y > 400) {
      backbtn.classList.add("is_active");
    } else {
      backbtn.classList.remove("is_active");
    }
  });
}
